module.exports = __webpack_public_path__ + "html/subscription-router-modals-container_129288ab615cea2022abc06d5bfbfb9e.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/containers/subscription-router-modals-container.html
// module id = 4Yp3
// module chunks = 63